import {
  Box,
  ButtonBase,
  IconButton,
  Input,
  makeStyles,
} from '@material-ui/core';
import DynamicIcon from 'components/Common/DynamicIcon';
import React from 'react';
import { newLineSplitter } from 'util/string';

const useStyles = makeStyles((theme) => ({
  textFieldContainer: {
    '&::-webkit-scrollbar': {
      height: 5,
      width: 5,
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD1D7',
      borderRadius: 3.5,
    },
  },
}));

const TextInputCell = React.memo(
  ({ row, column, rowState, handlePaste, handleRowChange }) => {
    const classes = useStyles();
    const [editableState, setEditableState] = React.useState(false);
    let inputFieldRef = React.useRef();

    const isNumerTypeCell = (column) =>{
      return [3, 4, 7].includes(column.columnContentType.dataType) ? true :false;
    }

    React.useEffect(() => {
      handleRowChange(row.id, {
        [column.key]:
        (isNumerTypeCell(column) ? parseInt((rowState || {})[column.key] || (row[column.key] || {}).value) : (rowState || {})[column.key] || (row[column.key] || {}).value ) || null,
      });
    }, [row]);

    React.useEffect(() => {
      const textLength = `${
        rowState[column.key] || (row[column.key] || {}).value || ''
      }`.length;
      inputFieldRef.current.focus();
      inputFieldRef.current.setSelectionRange(textLength, textLength);
    }, [editableState]);

    const onKeyPress = (e) => {
      const regex = /^[0-9.]+$/;
      if (
        isNumerTypeCell(column) &&
        !regex.test(e.key)
      ) {
        e.preventDefault();
      }
    };

    return (
      <div
        style={{ maxWidth: '100%', overflow: 'auto' }}
        className={classes.textFieldContainer}
      >
        <ButtonBase
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            color: (row[column.key] || {})['color'],
            width: '100%',
            paddingRight: 20,
            minWidth: 200,
            cursor: 'pointer',
          }}
          onClick={() => {
            setEditableState(true);
          }}
        >
          <Input
            inputRef={inputFieldRef}
            inputProps={{
              placeholder: column.hint || 'Enter Text',
            }}
            size="small"
            disableUnderline
            disabled={
              !editableState || (row[column.key] || {}).cellEditable === false
            }
            value={rowState[column.key]}
            onChange={(event) =>
              handleRowChange(row.id, { [column.key]: !!event.target.value && isNumerTypeCell(column) ? parseInt(event.target.value) : event.target.value})
            }
            autoFocus
            onPaste={(e) => {
              e.preventDefault();
              handlePaste(
                column.key,
                newLineSplitter(e.clipboardData.getData('Text'))
              );
            }}
            multiline
            fullWidth
            onBlur={() => setEditableState(false)}
            onKeyPress={onKeyPress}
            rowsMax={3}
            style={{ color: '#000000' }}
          />
          <div style={{ width: '30px' }}>
            {!editableState && (
              <IconButton
                style={{
                  marginTop: -2.5,
                }}
                onClick={() => {
                  setEditableState(true);
                }}
              >
                <DynamicIcon iconId={149} />
              </IconButton>
            )}
          </div>
        </ButtonBase>
      </div>
    );
  },
  (prevProps, currentProps) => {
    return (
      (prevProps.rowState || {})[(prevProps.column || {}).key] ===
        (currentProps.rowState || {})[(currentProps.column || {}).key] &&
      prevProps.selected === currentProps.selected &&
      ((prevProps || {}).rows || []).length ===
        ((currentProps || {}).rows || []).length
    );
  }
);

export default TextInputCell;
